'use client';

import type { Listing } from '@repo/api';
import { IconShare } from '@repo/svgs';
import { SaveListing } from '@/features/listings/SaveListing';
import { cn } from '@/lib/cn';
import { ShareButton } from '@/components/share/ShareButton';
import { useAnalytics } from '@/hooks/useAnalytics';

interface UnitImageActionsProps {
  listing: Listing;
  variant?: 'overlay' | 'inline';
  className?: string;
}

export function UnitImageActions({
  listing,
  variant = 'overlay',
  className,
}: UnitImageActionsProps) {
  const analytics = useAnalytics();
  const isOverlay = variant === 'overlay';

  const buttonClasses = cn(
    'flex items-center justify-center transition-colors rounded-full',
    isOverlay
      ? 'w-10 h-10 bg-white/90 hover:bg-white shadow-sm'
      : 'w-10 h-10 bg-transparent hover:bg-gray-100',
  );

  return (
    <div className={cn('flex items-center gap-2 -mr-2', className)}>
      <ShareButton
        className={buttonClasses}
        aria-label="Share"
        title="Listing"
        icon={<IconShare width={20} height={20} style={{ color: 'var(--icon-color-primary)' }} />}
      />
      <SaveListing
        listingId={listing.id}
        listingSlug={listing.slug}
        listing={listing}
        initialSaved={false}
        className={buttonClasses}
        iconClassName="w-5 h-5 !p-0"
        onSaveChange={saved =>
          saved
            ? analytics.track('unit_save', { unitId: listing.slug, addressSlug: listing.slug })
            : analytics.track('unit_unsave', { unitId: listing.slug, addressSlug: listing.slug })
        }
      />
    </div>
  );
}
